import { render, staticRenderFns } from "./Help.vue?vue&type=template&id=8241d9cc&scoped=true&"
import script from "./Help.vue?vue&type=script&lang=ts&"
export * from "./Help.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8241d9cc",
  null
  
)

export default component.exports